var _g, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackOverflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff9800"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.444 14.839 10.338 2.196.433-2.089-10.338-2.212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.215 17.571h10.566v2.127h-10.566z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.8 9.831 9.572 4.526.887-1.944-9.577-4.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.373 14.358-.001-.001-.001.001z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 15.429v8.571h18.992v-8.571h-2.113v6.428h-14.766v-6.428z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.453 5.063 8.109 6.873 1.346-1.65-8.109-6.873z",
    fill: "#ff9800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22 8.587-6.302-8.587-1.691 1.286 6.302 8.587z",
    fill: "#ff9800"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackOverflow);
export default __webpack_public_path__ + "static/media/stack-overflow.18f83535101e023ea94eec9983e1e8d2.svg";
export { ForwardRef as ReactComponent };